import React from 'react';
import PropTypes from 'prop-types';

const DashboardSection8 = ({ sectionSixArray, title, sectionSevenArray }) => {
  return (
    <div>
      <div className="border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl md:p-6 p-4 mt-5 dark:bg-shoorah-darkBgTabColor dark:border-none dark:text-shoorah-darkBg bg-white">
        <div className="text-lg md:text-xl font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-4">
          {title || 'Goals'}
        </div>
        <div className="grid gap-4 md:grid-cols-3 sm:grid-cols-2">
          {sectionSixArray?.length > 0
            ? sectionSixArray?.map((value, key) => (
                <div
                  key={key}
                  className={`lg:h-[135px] flex justify-between dark:bg-shoorah-darkBgColor flex-col lg:rounded-2xl rounded-xl p-4 text-black dark:text-shoorah-darkBg text-l font-medium bg-shoorah-normanGray`}
                >
                  <div className={`lg:text-base text-sm text-gray-400`}>{value.name}</div>
                  <div className={`text-lg lg:text-xl`}>{value.status ? value.status : 0}</div>
                </div>
              ))
            : null}
        </div>
        {sectionSevenArray?.length > 0 && (
          <>
            <div className="text-lg md:text-xl font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-4 lg:mt-6 mt-5">
              Top key words (Categories)
            </div>
            <div className="grid 2xl:grid-cols-5 lg:grid-cols-3 md:grid-cols-4 sm:grid-cols-2 grid-cols-1 2xl:gap-3 gap-4 mt-1">
              {sectionSevenArray?.map((value, key) => (
                <div
                  key={key}
                  className={`flex justify-center items-center flex-col lg:rounded-2xl rounded-xl px-4 md:py-6 py-4 text-black dark:text-shoorah-darkBg text-l font-medium dark:bg-shoorah-darkBgColor bg-shoorah-normanGray`}
                >
                  <div
                    className={`lg:text-base relative text-sm flex justify-between items-center text-gray-400`}
                  >
                    {value?.category}
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

DashboardSection8.propTypes = {
  sectionSixArray: PropTypes.any
};

export default DashboardSection8;
